/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

// Import console logger to suppress logs in production
import { setupConsoleLogger } from "./utils/consoleLogger";
import "react-app-polyfill/stable";

import * as React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

// Use consistent styling
import "sanitize.css/sanitize.css";

// Import root app
import { App } from "app";

import { HelmetProvider } from "react-helmet-async";

import { configureAppStore } from "store/configureStore";

import { ThemeProvider } from "styles/theme/ThemeProvider";

import reportWebVitals from "reportWebVitals";

// Initialize languages
import "./locales/i18n";

import { CssVarsProvider } from "@mui/joy/styles";
import Sheet from "@mui/joy/Sheet";

// Import dependencies
import { Toaster } from "react-hot-toast";

import "@fontsource/open-sans"; // Defaults to weight 400
import AuthProvider from "./aws/AuthContext";

//
//  Redux Store
//
const store: any = configureAppStore();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// AWS Configuration (if needed)

root.render(
  <Provider store={store}>
    <AuthProvider>
      <ThemeProvider>
        <HelmetProvider>
          {/* Disabled due to error with react-beautiful-dnd */}
          {/* <React.StrictMode> */}
          <CssVarsProvider>
            <Sheet variant="soft">
              <Toaster />
              <App />
            </Sheet>
          </CssVarsProvider>
          {/* </React.StrictMode> */}
        </HelmetProvider>
      </ThemeProvider>
    </AuthProvider>
  </Provider>
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(["./locales/i18n"], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals.console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Setup console logger to suppress logs in production environment
setupConsoleLogger();
